export default __webpack_public_path__ + "static/B0028-6d1ac8fef7530961a6099b2d472fc0a7.png";